export interface DealSyncContact {
  contactEmail: string
  contactName: string
}

export type DealSyncContactResponse = DealSyncContact[]

export const LOCAL_STORAGE_KEY_GOOGLE = 'connecting-deal-sync-google-url'